import fetchIntercept from 'fetch-intercept';
import { configTypes } from '../store';

export default {
  setupInterceptors: (store) => {
    fetchIntercept.register({
      request: function (url, config) {
        // Modify the url or config here
        return [url, config];
      },

      requestError: function (error) {
        // Called when an error occured during another 'request' interceptor call
        return Promise.reject(error);
      },

      response: function (response) {
        // Modify the reponse object
        store.dispatch({ type: configTypes.AUTHORIZED });
        return response;
      },

      responseError: function (error) {
        // Handle an fetch error
        // If forbidden, the user is trying to do something they shouldn't be doing...
        if (error.response.status === 403) {
          localStorage.clear();
          store.dispatch({ type: configTypes.UNAUTHORIZED });
        }

        return Promise.reject(error);
      }
    })
  }
};